import { KBUrl, TooltipReadMoreKbLink } from '@upright/ui/common/upright/kb-urls';

export const netImpactLensTexts = {
  LensTitle: () => <>Upright net impact</>,
  LensDescription: () => <>Comprehensive net impact quantification</>,
  LensTooltipContent: () => {
    return (
      <>
        A comprehensive quantification of the net impact a company, fund, portfolio, or other set of companies,
        including both their negative and positive impacts; what “resources” they use or “costs” they create - and what
        they get done, or what are the “gains”.
        <TooltipReadMoreKbLink href={KBUrl.METRICS_NET_IMPACT} />
      </>
    );
  },
  SourceDescription: () => <>Upright net impact model</>,
  SourceTooltipContent: () => (
    <>
      <div>
        The Upright net impact model is a mathematical model of the global economy that integrates information from a
        variety of public data sources to produce comparable net impact profiles of companies, along with complementary
        indicators.
        <TooltipReadMoreKbLink href={KBUrl.METHODOLOGY_NET_IMPACT} />
      </div>
    </>
  ),
};
